// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z5q0","content":"styles_content__2A2gx","row":"styles_row__2xJri","footer":"styles_footer__1RhuN","phraseLength":"styles_phraseLength__2e0ce"};